<template>
  <!-- 历史记录 -->
  <div v-if="isShow && list.length > 0" class="history-dropdown">
    <div class="history-header">
      <span>最近搜索历史</span>
    </div>
    <div>
      <div
        v-for="(item, index) in list"
        :key="index"
        @mousedown="$emit('select', item)"
        class="history-item"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchHistory",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="less" scoped>
@import "@/assets/css/newhomepage/searchinput.less";
</style>
